import Enumerable from 'linq'

class Dictionary {

  constructor({valueKey = 'value', textKey = 'text', data = []}) {
    this.valueKey = valueKey;
    this.textKey = textKey;
    this.data = data;
  }

  getText(value) {
    let text = value;
    for (let i = 0, l = this.data.length; i < l; i++) {
      if (String(this.data[i][this.valueKey]) === String(value)) {
        text = this.data[i][this.textKey];
        break;
      }
    }
    return text;
  }

  getValues() {
    let values = [];
    for (let i = 0, l = this.data.length; i < l; i++) {
      values.push(this.data[i][this.valueKey]);
    }
    return values;
  }

  getTexts() {
    let values = [];
    for (let i = 0, l = this.data.length; i < l; i++) {
      values.push(this.data[i][this.textKey]);
    }
    return values;
  }
}

const departmentIdKey = 'id', departmentNameKey = 'name';

function getDepartmentsDictionary(departments) {
  return new Dictionary({data: departments, valueKey: departmentIdKey, textKey: departmentNameKey});
}

function getZeroDepartmentNames(allDepartmentNames, departmentNames) {
  let zeroDepartmentNames = [];
  for (let i = 0, l = allDepartmentNames.length; i < l; i++) {
    if (departmentNames.indexOf(allDepartmentNames[i]) === -1) {
      zeroDepartmentNames.push(allDepartmentNames[i]);
    }
  }
  return zeroDepartmentNames;
}

function getDepartmentPersonDictionary(persons) {
  return Enumerable.from(persons).groupBy(x => x.department)
      .select(x => ({department: x.key(), personids: x.getSource().map(e => e.personid)}))
      .toDictionary(x => String(x.department), x => x.personids)
}

let barMaxWidth = '20px';


function asc(a, b, key) {
  return a[key] < b[key] ? -1 : a[key] === b[key] ? 0 : 1;
}

function desc(a, b, key) {
  return a[key] < b[key] ? 1 : a[key] === b[key] ? 0 : -1;
}

export default {
  abstractAddCountByDepartmentChartOption(state) {
    let option = {
      title: { text: '数据中心知识贡献' },
      tooltip: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        type: 'category',
        data: []
      },
      series: []
    };
    let d = getDepartmentsDictionary(state.departments);
    let departmentNames = state.abstractAddCountByDepartment.map(e => d.getText(e.departmentId));
    let abstractTotals = state.abstractAddCountByDepartment.map(e => e.abstractTotal);
    let zeroDepartmentNames = getZeroDepartmentNames(d.getTexts(), departmentNames);
    for (let i = 0, l = zeroDepartmentNames.length; i < l; i++) {
      departmentNames.unshift(zeroDepartmentNames[i]);
      abstractTotals.unshift(0);
    }
    option.yAxis.data = departmentNames;
    option.series = [{
      name: '知识点数量',
      type: 'bar',
      barMaxWidth: barMaxWidth,
      data: abstractTotals
    }];
    return option;
  },
  abstractClickCountByDepartmentChartOption(state) {
    let option = {
      title: { text: '数据中心知识阅读量' },
      tooltip: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        type: 'category',
        data: []
      },
      series: []
    };
    let departmentClickTotals = [];
    let departmentPersonDictionary = getDepartmentPersonDictionary(state.persons);
    console.log('departmentPersonDictionary', departmentPersonDictionary);
    for (let i = 0, l = state.departments.length; i < l; i++) {
      let department = state.departments[i],
          departmentId = String(department[departmentIdKey]),
          departmentName = department[departmentNameKey],
          clickTotal = 0
      ;
      if (departmentPersonDictionary.contains(departmentId)) {
        let personids = departmentPersonDictionary.get(departmentId);
        for (let j = 0, jl = state.userClickCount.length; j < jl; j++) {
          if (personids.indexOf(state.userClickCount[j]['username']) !== -1) {
            clickTotal += state.userClickCount[j]['abstractTotal'];
          }
        }
      }
      departmentClickTotals.push({
        departmentName: departmentName,
        clickTotal: clickTotal
      });
    }
    departmentClickTotals = departmentClickTotals.sort((a, b) => asc(a, b, 'clickTotal'));
    let departmentNames = departmentClickTotals.map(e => e.departmentName);
    let clickTotals = departmentClickTotals.map(e => e.clickTotal);
    option.yAxis.data = departmentNames;
    option.series = [{
      name: '知识阅读量',
      type: 'bar',
      barMaxWidth: barMaxWidth,
      data: clickTotals
    }];
    return option;
  },
  abstractHotByDepartmentChartOption(state) {
    let option = {
      title: { text: '数据中心知识阅读热度' },
      tooltip: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        type: 'category',
        data: []
      },
      series: []
    };
    let departmentHotDiffTotals = [];
    for (let i = 0, l = state.departments.length; i < l; i++) {
      let department = state.departments[i],
          departmentId = department[departmentIdKey],
          departmentName = department[departmentNameKey],
          hotDiffTotal = 0
      ;
      for (let j = 0, jl = state.abstractHot.length; j < jl; j++) {
        if (String(departmentId) === String(state.abstractHot[j]['departmentId'])) {
          hotDiffTotal += state.abstractHot[j]['hotDiffTotal'];
        }
      }
      departmentHotDiffTotals.push({
        departmentName: departmentName,
        hotDiffTotal: hotDiffTotal
      });
    }
    departmentHotDiffTotals = departmentHotDiffTotals.sort((a, b) => asc(a, b, 'hotDiffTotal'));
    let departmentNames = departmentHotDiffTotals.map(e => e.departmentName);
    let hotTotals = departmentHotDiffTotals.map(e => e.hotDiffTotal.toFixed(2));
    option.yAxis.data = departmentNames;
    option.series = [{
      name: '知识阅读热度',
      type: 'bar',
      barMaxWidth: barMaxWidth,
      data: hotTotals
    }];
    return option;
  },
  abstractAddCountByUserChartOption(state) {
    let option = {
      title: { text: '个人知识贡献TOP10' },
      tooltip: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        type: 'category',
        data: []
      },
      series: []
    };
    let yData = state.abstractAddCountByUser.map(e => e.creatorName);
    let xData = state.abstractAddCountByUser.map(e => e.abstractTotal);
    option.yAxis.data = yData;
    option.series = [{
      name: '个人知识贡献',
      type: 'bar',
      barMaxWidth: barMaxWidth,
      data: xData
    }];
    return option;
  },
  userClickCountChartOption(state) {
    let option = {
      title: { text: '个人阅读TOP10' },
      tooltip: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        type: 'category',
        data: []
      },
      series: []
    };
    let userClickCountTop10 = state.userClickCount.sort((a, b) => asc(a, b, 'abstractTotal')).filter((value, index) => index < 10);
    let yData = userClickCountTop10.map(e => e.realName);
    let xData = userClickCountTop10.map(e => e.abstractTotal);
    option.yAxis.data = yData;
    option.series = [{
      name: '个人阅读',
      type: 'bar',
      barMaxWidth: barMaxWidth,
      data: xData
    }];
    return option;
  },
  abstractHotChartOption(state) {
    let option = {
      title: { text: '知识阅读热度TOP10' },
      tooltip: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        type: 'category',
        axisLabel: {
          formatter: function (value) {
            return value.length > 10 ? value.substring(0, 10) + '...' : value;
          }
        },
        data: []
      },
      series: []
    };
    let hotDiffTotalTop10 = state.abstractHot.sort((a, b) => desc(a, b, 'hotDiffTotal')).filter((value, index) => index < 10).reverse();
    let yData = hotDiffTotalTop10.map(e => e.abstractDescription);
    let xData = hotDiffTotalTop10.map(e => e.hotDiffTotal.toFixed(2));
    option.yAxis.data = yData;
    option.series = [{
      name: '知识阅读热度',
      type: 'bar',
      barMaxWidth: barMaxWidth,
      data: xData
    }];
    return option;
  }
}